/**
 * @file 角色管理-
 */

const state = {
    isImportType3DetailList: false,
    isImportType1DetailList: false,
    isEditByExtType3: false,
    isEditByExtType1: false,
    isEditByExtType5: false,
    isEditByExtType2: false,
    isResetToDefault: false,
}

const mutations = {
    'SET_IS_IMPORT_TYPE1_DETAIL_LIST'(state, isImportType1DetailList) {
        state.isImportType1DetailList = isImportType1DetailList
    },
    'SET_IS_IMPORT_TYPE3_DETAIL_LIST'(state, isImportType3DetailList) {
        state.isImportType3DetailList = isImportType3DetailList
    },
    'SET_IS_EDIT_BY_EXT_TYPE3'(state, isEditByExtType3) {   
        state.isEditByExtType3 = isEditByExtType3
    },
    'SET_IS_EDIT_BY_EXT_TYPE5'(state, isEditByExtType5) {
        state.isEditByExtType5 = isEditByExtType5
    },
    'SET_IS_EDIT_BY_EXT_TYPE2'(state, isEditByExtType2) {
        state.isEditByExtType2 = isEditByExtType2
    },
    'SET_IS_EDIT_BY_EXT_TYPE1'(state, isEditByExtType1) {
        state.isEditByExtType1 = isEditByExtType1
    },
    'SET_IS_RESET_TO_DEFAULT'(state, val) {
        state.isResetToDefault = val
    }
}

export default {
    state,
    mutations
}
